import { useSelector } from "react-redux";
import { ALL_ICONS } from "../../../../assets/icons/AllIcons";
import CurrencyText from "../../../../components/fragment/cur-text/CurrencyText";
import { RazorNumberFormat } from "../../../../components/razor-reuse";
import ThirdPartyLayout from "../ThirdPartyLayout";
import { RootState } from "../../../../redux/store";
import { useState } from "react";
import ZojapayPaymentDetailsModal from "./ZojapayPaymentDetailsModal";

export default function ZojapayIndex() {
  const [displayDetails, setDisplayDetails] = useState<{
    modal: boolean;
    payment_details?: Record<string, string | string[]> | null;
  }>({
    modal: false,
    payment_details: null,
  });
  const { zojapay } = useSelector((state: RootState) => state.thirdParty);
  return (
    <>
      <ThirdPartyLayout
        titleText="Here are the details about your zojapay account"
        title="Zojapay Account"
      >
        <div className="blaze-index-wrapper-box-third-party">
          <div
            style={{
              background:
                "linear-gradient( to right , #312e81 0%, #e1efe5 100% )",
            }}
            className="card-amount-box"
          >
            <CurrencyText
              imgSize={`3rem`}
              text="NGN Wallet"
              className="currency-text-box"
              currency={"ngn"}
            />
            <div className="label-value-box">
              <p className="label">{`Current Balance`}</p>
              <p className="value">
                {RazorNumberFormat(zojapay?.account?.availableBalance, {
                  symbol: "ngn",
                })}
              </p>
            </div>
            {/* btn action box start  */}
            <div className="btn-action-box">
              <div
                className="btn-wrap"
                onClick={() => {
                  setDisplayDetails({
                    modal: true,
                    payment_details: zojapay?.account,
                  });
                }}
              >
                <div className="icon-wrap">
                  <figure className="img-box">{ALL_ICONS?.fund_icon}</figure>
                </div>
                <p className="text">Fund</p>
              </div>
            </div>
            {/* btn action box end */}
          </div>
        </div>
      </ThirdPartyLayout>
      <ZojapayPaymentDetailsModal
        visible={displayDetails?.modal}
        onClose={() => {
          setDisplayDetails({
            modal: false,
            payment_details: null,
          });
        }}
        payment_details={displayDetails.payment_details}
      />
    </>
  );
}
